import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const PrivateRoute = () => {
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("userRole");

  // Only allow if token exists AND role is "admin"
  if (token && role === "admin") {
    return <Outlet />;
  }

  // Otherwise redirect to login
  return <Navigate to="/login-register" replace />;
};

export default PrivateRoute;